import { includes, remove } from "lodash";

export function useArrayToggle() {
    const toggleArrayItem = (array, item) => {
        if (includes(array, item)) {
            remove(array, (i) => i === item);
        } else {
            array.push(item);
        }
    };

    return { toggleArrayItem };
}
